<template>
    <section class="q10__page my-14">
        <div class="container px-11 2xl:px-3 m-auto">
            <div class="q10__article_container__title_head m-4">
                <article-title-tour
                        :options="{
                        tourtitle: currentPage.content.tourtitle.text,
                        titlecolor: 'text-flamingo',
                        toursubtitle: currentPage.content.toursubtitle.text,
                        subtitlecolor: 'text-nandor',
                    }"
                ></article-title-tour>
            </div>
            <div class="container-components">
                <div class="card break-inside-avoid">
                    <hotspot-richmedia
                            :options="{
                            icon: 'diaporama',
                            collection: getRichmediaByCollection(
                                currentPage,
                                'Création de la mission Maitrise des Risques en 2011'
                            ),
                        }"
                            class="top-3 md:top-3 -right-2"
                    />

                </div>
                <div class="card break-inside-avoid">
                    <div class="relative top-0 left-0 w-full">
                        <image-with-descriptions
                                class="mt-1 mb-1"
                                :options="{
                                image300:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image2.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image2.edf,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                        fontSize: 'text-xs md:text-base',
                                    },
                                ],
                            }"
                        />
                    </div>
                    <div class="absolute top-0 left-0 p-7 xl:p-3 2xl:p-7">
                        <TimelineTitle
                                :options="{
                                year: currentPage.content.secondYear.text,
                                pretitle:
                                    currentPage.content.secondPretitle.text,
                                title: currentPage.content.secondTitle.text,
                                content: currentPage.content.secondContent.text,
                                fontSize: {},
                                color: {
                                    year: 'text-yellow-500',
                                    pretitle: 'text-white',
                                    title: 'text-white',
                                    content: 'text-white',
                                },
                            }"
                        >
                        </TimelineTitle>
                    </div>
                </div>
                <div class="card break-inside-avoid">
                    <hotspot-richmedia
                            :options="{
                            icon: 'diaporama',
                            collection: getRichmediaByCollection(
                                currentPage,
                                'Projet performance, Hydreole, numero spécial, decembre 2014'
                            ),
                        }"
                            class="top-9 -right-2 md:top-5 lg:top-5"
                    />

                    <TimelineTitle
                            :options="{
                            year: currentPage.content.thirdYear.text,
                            pretitle: currentPage.content.thirdPretitle.text,
                            title: currentPage.content.thirdTitle.text,
                            content: currentPage.content.thirdContent.text,

                            fontSize: {
                                pretitle: 'text-base 2xl:text-4xl',
                                title: 'text-3xl 2xl:text-4xl',
                            },
                            color: {
                                title: 'text-flamingo',
                            },
                        }"
                    >
                    </TimelineTitle>
                </div>
                <div class="card break-inside-avoid">
                    <TimelineTitle
                            :options="{
                            year: currentPage.content.fourthYear.text,
                            pretitle: currentPage.content.fourthpPetitle.text,
                            title: currentPage.content.fourthTitle.text,
                            content: currentPage.content.fourthContent.text,

                            fontSize: {
                                pretitle: 'text-2xl 2xl:text-4xl',
                                title: 'text-3xl 2xl:text-4xl',
                            },
                            color: {
                                title: 'text-flamingo',
                            },
                        }"
                    >
                        <template v-slot:bottom class="relative">
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                    :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.image3.src,
                                }"
                            />
                            <span
                                    class="q10__copyright"
                                    v-html="currentPage.images.image3.text"
                            ></span>
                        </template>
                    </TimelineTitle>
                </div>
                <div class="card break-inside-avoid">
                   
                    <TimelineTitle
                            :options="{
                            year: currentPage.content.fifthYear.text,
                            pretitle: currentPage.content.fifthPretitle.text,
                            title: currentPage.content.fifthTitle.text,
                            content: currentPage.content.fifthContent.text,

                            fontSize: {
                                pretitle: 'text-base 2xl:text-lg',
                                title: 'text-3xl 2xl:text-3xl',
                            },
                            color: {
                                title: 'text-flamingo',
                            },
                        }"
                    >
                        <div class="relative w-full h-full">
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                    :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.image4.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image4
                                                .text,
                                            position: 'top-left', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                            fontSize: 'text-xs md:text-base',
                                        },
                                        {
                                            text: currentPage.images.image4.alt,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'horizontal', // vertical, horizontal
                                            fontSize: 'text-xs md:text-base',
                                        },
                                    ],
                                }"
                            />

                            <div
                                    class="
                                    absolute
                                    top-8
                                    md:top-10
                                    right-0
                                    p-2
                                    text-right
                                "
                            >
                                <paragraph
                                        class="paragrafSchimbat"
                                        :options="{
                                        color: 'text-white',
                                    }"
                                >
                                </paragraph>
                            </div>
                        </div>
                    </TimelineTitle>
                </div>


                <div class="card break-inside-avoid">
                    <div class="relative">
                        <hotspot-richmedia
                            :options="{
                            icon: 'diaporama',
                            collection: getRichmediaByCollection(
                                currentPage,
                                    'Souvenirs des challenges de linnovation'
                                ),
                            }"
                                class="top-3 lg:top-5 -right-2"
                        />
                    </div>
                    <TimelineTitle
                            :options="{
                            year: currentPage.content.sixthYear.text,
                            pretitle: currentPage.content.sixthPretitle.text,
                            title: currentPage.content.sixthTitle.text,

                            fontSize: {
                                pretitle: 'text-sm 2xl:text-lg',
                                title: 'text-2xl 2xl:text-3xl',
                            },
                            color: {
                                title: 'text-flamingo',
                            },
                        }"
                    >
                        <template v-slot:top class="relative">
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                    :options="{
                                image:
                                    'pages/' +
                                    currentPage.slug +
                                    '/' +
                                    currentPage.images.image5.src,
                                descriptions: [
                                    {
                                        text: currentPage.images.image5.text,
                                        position: 'bottom-right', // top/bottom-left/right
                                        orientation: 'horizontal', // vertical, horizontal
                                        fontSize: 'text-xs md:text-base',
                                    },
                                ],
                            }"
                            />
                        </template>

                        <div class="" v-html="currentPage.content.sixthContent.text">
                        </div>

                    </TimelineTitle>

                </div>

                <div class="card break-inside-avoid">
                    <hotspot-richmedia
                            :options="{
                            icon: 'diaporama',
                            collection: getRichmediaByCollection(
                                currentPage,
                                'Évolution des résultats sécurité'
                            ),
                        }"
                            class="top-20 -right-2 md:top-3 lg:top-5 xl:top-2 2xl:top-5"
                    />

                    <TimelineTitle
                            :options="{
                            year: currentPage.content.seventhYear.text,
                            pretitle: currentPage.content.seventhPretitle.text,
                            title: currentPage.content.seventhTitle.text,
                            content: currentPage.content.seventhContent.text,

                            fontSize: {
                                pretitle: 'text-base 2xl:text-lg',
                                title: 'text-3xl 2xl:text-3xl',
                            },
                            color: {
                                title: 'text-flamingo',
                            },
                        }"
                    >
                        <template v-slot:bottom>
                            <image-with-descriptions
                                    class="mt-1 mb-1"
                                    :options="{
                                    image:
                                        'pages/' +
                                        currentPage.slug +
                                        '/' +
                                        currentPage.images.image6.src,
                                    descriptions: [
                                        {
                                            text: currentPage.images.image6
                                                .text,
                                            position: 'bottom-right', // top/bottom-left/right
                                            orientation: 'vertical', // vertical, horizontal
                                            color: 'text-nandor',
                                            fontSize: 'text-xs md:text-base',
                                        },
                                    ],
                                }"
                            />
                        </template>
                    </TimelineTitle>
                </div>
            </div>
        </div>

        <timeline-carousel
                :options="{
                timeline: currentPage.timeline,
            }"
        />
    </section>
</template>

<script>
import PagesMixin from "@/mixins/PagesMixin";

export default {
    name: "PageTest",
    mixins: [PagesMixin],
};
</script>

<style scoped lang='scss'>
.container-components {
    //column-width: 350px;
    //column-gap: 10px;

    .item {
        position: relative;
        margin: 5px 0;
        padding: 0;
        display: inline-block;
        width: 100%;
        height: auto;
    }

    .paragrafSchimbat {
        font-size: 1.3rem !important;
        line-height: 1.2rem !important;
        font-weight: 300 !important;
        @media screen and (max-width: 768px) {
            font-size: 0.9rem !important;
        }
    }
}

.q10__copyright {
    bottom: -2%;
    position: absolute;
    right: 7%;
    font-size: 12px;
}
</style>
